import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { SBW_TIMEOUT } from '../constants/common.constants';
import { EndpointKeys, IDP_APPS } from '../constants/urls.constants';
import { DefaultLookupResponse } from '../models/core-apis/default-lookup.interfaces';

@Injectable({
  providedIn: 'root'
})
export class DefaultLookupService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService
  ) {}

  getDefaultLookupApi(cacheKeySuffix = ''): Observable<DefaultLookupResponse> {
    const headers: HttpHeadersPayload = {
      cachekey: cacheKeySuffix
    };
    return new ApiBuilder<string, DefaultLookupResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.BOOK_WIDGET)
      .endpointKey(EndpointKeys.DEFAULT_LOOKUP_API_URL)
      .method(HttpRequestMethods.GET_HEADERS)
      .httpHeaders(headers)
      .timeOut(SBW_TIMEOUT.COMMON)
      .errorHandler(this._handleError.bind(this))
      .create();
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
